module.exports = __webpack_public_path__ + "media/images/flags/ai-667cd16b5d6f52954bafffd4b71c0c3b.svg";